export type OutboxStatus = 'pending' | 'syncing' | 'failed' | 'done';

export interface OutboxItem {
  id: string;
  platform: string;
  method: string;
  path: string;
  body: string | null;
  idempotencyKey: string;
  createdAt: number;
  attempts: number;
  nextAttemptAt: number;
  status: OutboxStatus;
  lastError?: string;
  /** Optional entity key for serializing flushes (e.g. projectId). */
  entityKey?: string;
}

export type ConnectionState =
  | 'online'
  | 'offline'
  | 'backend_unreachable'
  | 'syncing'
  | 'degraded';

export interface SiteSnapshot {
  slug: string;
  savedAt: number;
  /** JSON string of site payload (pages, meta, etc.). */
  payloadJson: string;
  /** Approximate byte size for quota checks. */
  bytes: number;
}

export const OFFLINE_SCHEMA_VERSION = 1;
export const DEFAULT_SITE_SNAPSHOT_BUDGET_BYTES = 8 * 1024 * 1024;
